module.exports = __webpack_public_path__ + "static/media/42-1.c55aa524.mp3";